<template>
<!-- 未使用ファイル -->
    <layout title="ブランド一覧">
        <main class="ly_main _brand"><div class="wrap"><div class="inner">
            <!--Heading-->
            <h1 class="heading_page-title flex _y-center">
                <div class="main"><span>ブランド一覧</span></div>
                <div class="controller flex _right _y-center">
                    <div class="form_search">
                        <input type="search">
                        <label for="submit-btn" class="md_svg-icon">
                            <SvgIconSearch />
                        </label>
                        <input type="submit" id="submit-btn">
                    </div><!--/.search-->
                    <div>
                        <a class="btn_link md_icon-text" href=""><div class="inner">
                            <span>
                                新規追加
                                <div class="icon">
                                    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11 17C11 15.3431 12.3431 14 14 14H86C87.6569 14 89 15.3431 89 17V46.2131C89 47.87 87.6569 49.2131 86 49.2131H79.1817V83C79.1817 84.6569 77.8385 86 76.1817 86H23.8181C22.1612 86 20.8181 84.6569 20.8181 83V49.2131H14C12.3431 49.2131 11 47.87 11 46.2131V17ZM17 20V43.2131H23.8181C25.4749 43.2131 26.8181 44.5563 26.8181 46.2131V80H73.1817V46.2131C73.1817 44.5563 74.5248 43.2131 76.1817 43.2131H83V20H17Z" fill="white"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M31.7278 18.082C32.454 27.2954 40.2454 34.4949 49.6793 34.4949C59.1133 34.4949 66.9047 27.2954 67.6309 18.082H61.6016C60.8957 23.9201 55.8569 28.4949 49.6793 28.4949C43.5018 28.4949 38.463 23.9201 37.7571 18.082H31.7278Z" fill="white"/>
                                    </svg>
                                </div>
                            </span>
                        </div></a>
                    </div><!--/.add-->
                </div><!--/.controller-->
            </h1><!--/.heading_page-title-->
            <!--BlandList-->
            <div class="md_common-bl" id="bland-list">
                <div class="inner">
                    <div class="table_common _use-checkbox">
                        <table>
                            <thead>
                                <tr>
                                    <th class="form_checkbox">
                                        <input type="checkbox" name="checkbox1" id="checkbox-all">
                                        <label for="checkbox-all"></label>
                                    </th>
                                    <th>ブランド名</th>
                                    <th>プラン</th>
                                    <th>ステータス</th>
                                    <th class="icon"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <!--Item-->
                                <tr v-for="(brand, index) in brands" :key="index">
                                    <td class="form_checkbox">
                                        <input type="checkbox" name="checkbox1" :id="'checkbox1-' + (index + 1)">
                                        <label :for="'checkbox1-' + (index + 1)"></label>
                                    </td>
                                    <td>
                                        <a class="ovl" href=""></a>
                                        {{brand.name}}
                                    </td>
                                    <td>{{brand.plan}}</td>
                                    <td>{{brand.publish}}</td>
                                    <th class="icon">
                                        <a href="">
                                            <svg class="md_svg-icon" width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M73.4942 12.8786C74.6657 11.7071 76.5652 11.7071 77.7368 12.8786L88.9961 24.138C90.1677 25.3095 90.1677 27.209 88.9961 28.3806L86.8748 26.2593C88.9961 28.3806 88.9963 28.3804 88.9961 28.3806L49.6804 67.6963C49.277 68.0997 48.767 68.3797 48.2102 68.5035L33.7315 71.7229C32.7301 71.9456 31.6844 71.6411 30.959 70.9158C30.2336 70.1904 29.9292 69.1447 30.1518 68.1433L33.3713 53.6645C33.4951 53.1077 33.7751 52.5977 34.1784 52.1944L73.4942 12.8786ZM82.6321 26.2593L75.6155 19.2426L39.0386 55.8194L37.0323 64.8424L46.0553 62.8361L82.6321 26.2593Z" fill="#070809"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M64.4827 21.8901C65.6543 20.7185 67.5538 20.7185 68.7253 21.8901L79.9846 33.1494C81.1562 34.321 81.1562 36.2205 79.9846 37.3921C78.8131 38.5636 76.9136 38.5636 75.742 37.3921L64.4827 26.1328C63.3111 24.9612 63.3111 23.0617 64.4827 21.8901Z" fill="#070809"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M19 26.1538H40.4225C42.0794 26.1538 43.4225 27.497 43.4225 29.1538C43.4225 30.8107 42.0794 32.1538 40.4225 32.1538H22V81H70.8461V60.0157C70.8461 58.3588 72.1893 57.0157 73.8461 57.0157C75.503 57.0157 76.8461 58.3588 76.8461 60.0157V84C76.8461 85.6568 75.503 87 73.8461 87H19C17.3431 87 16 85.6568 16 84V29.1538C16 27.497 17.3431 26.1538 19 26.1538Z" fill="#070809"/>
                                            </svg>
                                        </a>
                                    </th>
                                </tr><!--/.Item-->
                            </tbody>
                        </table>
                </div><!--/.table_common-->
            </div><!--/.md_common-bl-->
        </div></div></div><div class="heading_page-title-en"><span></span></div></main>
    </layout>
</template>

<script>
    import AdminLayout from '@/Layouts/AdminLayout'

    //Svg
    import SvgIconSearch from '@/components/EndUser/svg/SvgIconSearch'

    import ScrollHint from 'scroll-hint';

    export default {
        layout: AdminLayout,
        components: {
            //Svg
            "ScrollHint": ScrollHint,
            SvgIconSearch
        },
        props:{
            brands: {
                type: Array,
            }
        },
        data() {
            return {
                //ブランドリストのループ
                //課金履歴のループ
                billingHistorys: [
                    { planName : "Basic", licenceStatus: "買い切り", dayStart: "2021.10.04", dayEnd: "2021.10.31", planPrice: "4,950"},
                    { planName : "Basic", licenceStatus: "月間", dayStart: "2021.10.04", dayEnd: "2021.10.31", planPrice: "4,950"},
                    { planName : "Free", licenceStatus: "-", dayStart: "2021.10.04", dayEnd: "2021.10.31", planPrice: "0"},
                    { planName : "Basic", licenceStatus: "年間", dayStart: "2021.10.04", dayEnd: "2021.10.31", planPrice: "4,950"},
                ]
            }
        },
        mounted() {
            new ScrollHint('.table_common');
        }
    }
</script>
